import * as React from 'react';
import { RootContext, VideoInstitutionMenuTreatmentPath } from '../../../index';

export default class ExaminationExitView extends React.Component {
  static contextType = RootContext;

  onClickMenu (url) {
    const ids = location.pathname.split('/').filter(s => s !== '').slice(-7);
    location.href = `${VideoInstitutionMenuTreatmentPath(ids[0], ids[2], ids[4])}${location.search}`;
  }

  render () {
    return (
      <div className="p-examination">
        <div className="p-examination--content">
          {this.context.formatSimple(this.context.t('ExaminationExitView.message'))}
          <div className="mt-lg">
            <button className="c-mn-btn--first c-mn-btn--green" onClick={ () => { this.onClickMenu(); } }><span>{this.context.t('ExaminationExitView.button')}</span></button>
          </div>
        </div>
      </div>
    );
  }
}
